var _g, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_2761_3704)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    fill: "#F67989"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0531 14.0524L22.5707 12.1205C17.6155 10.7928 12.8759 13.5324 11.5464 18.4944L13.4782 19.012C14.5296 15.0884 18.1353 13.0026 22.0531 14.0524Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1627 19.9991C17.707 17.9677 18.8056 17.3335 20.837 17.8778L21.3546 15.9459C18.2395 15.1112 16.0656 16.3663 15.2309 19.4814L17.1627 19.9991ZM23.3059 18.1024C23.0875 18.2428 22.9322 18.4626 22.8728 18.7154C22.8133 18.9682 22.8545 19.2341 22.9875 19.4572L24.7452 22.4056C24.4899 22.9335 23.8415 23.9586 22.3845 24.8022C20.9236 25.6449 19.7088 25.6931 19.1286 25.6484L17.4526 22.6535C17.3261 22.4267 17.1163 22.2579 16.8676 22.183C16.619 22.108 16.3509 22.1328 16.1201 22.252L11.2392 24.7695C11.0078 24.8886 10.832 25.0933 10.7491 25.34C10.6662 25.5866 10.6827 25.8559 10.7952 26.0906L12.0311 28.6683C12.154 28.8802 12.3503 29.0397 12.5829 29.1164C12.8205 29.1956 18.4667 31.0046 24.0927 27.7581C28.998 24.9251 30.5798 20.154 30.9375 18.819C30.9898 18.6239 31.0161 18.5026 31.0227 18.4702C31.0728 18.2305 31.0324 17.9807 30.9093 17.769L29.2937 15.4105C29.1468 15.1957 28.922 15.0466 28.667 14.9949C28.4119 14.9431 28.1468 14.9929 27.9278 15.1335L23.3059 18.1024Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_2761_3704",
    x: -4,
    y: -4,
    width: 50,
    height: 50,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2761_3704"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2761_3704",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup10);
export default __webpack_public_path__ + "static/media/Group10.4e61823c97f94b683b9942fb3684a056.svg";
export { ForwardRef as ReactComponent };